<template lang="pug">
.vvvpass
  .vvvpass__picture
    p.vvvpass__title(v-if="isTrial") VVV Pass (7 days free)
    p.vvvpass__title(v-else) VVV Season Pass

    .vvvpass__price
      .vvvpass__old(v-if="showOldPrice") {{ computedOriginalPrice }} €
      Currency(type="money" real)
        span {{ subscriptionPrice }}

  .vvvpass__header {{ $t('bonuses') }}:

  .vvvpass__points
    .vvvpass__point(v-for="point in points" :key="point")
      img.vvvpass__star(:src="require('~/assets/img/icons/star-gold.svg')" alt="star")
      .vvvpass__point-text(v-t="point")

  .vvvpass__comment(v-if="isTrial" v-t="'vvvPassCardPoint5Comment'")
  .vvvpass__comment(v-else)

  //.vvvpass__duration(v-t="'subscriptionStart1610'")
  .vvvpass__duration(v-if="isTrial" v-t="'subscriptionDuration30'")
  .vvvpass__duration(v-else v-t="'subscriptionDurationSeason1'")

  Button.vvvpass__button(
    v-if="canBuy"
    is-primary
    @click="buy"
  ) {{ $t('buy') }}
</template>

<script>
export default {
  name: 'VVVPass',

  props: {
    subscription: {
      type: Object,
      required: true
    },

    userSubscriptions: {
      type: Array,
      default: new Array(...[])
    },

    isTrial: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    subscriptionPrice () {
      return this.subscription?.price
    },

    computedOriginalPrice () {
      return (this.subscription?.original_price / 100).toFixed(2).replace('.00', '')
    },

    showOldPrice () {
      return !!this.subscription?.extra_data?.discount?.amount
    },

    canBuy () {
      if (!this.isTrial) {
        return false
      }
      return !this.userSubscriptions?.find(s => s.start_date)
    },

    points () {
      return this.isTrial ? [
        'vvvPassCardPoint1',
        'vvvPassCardPoint2',
        'vvvPassCardPoint3',
        'vvvPassCardPoint4',
        'vvvPassCardPoint5'
      ] : [
        'vvvPassCardPoint1',
        'vvvPassCardPoint2',
        'vvvPassCardPoint3',
        'vvvPassCardPoint7'
      ]
    }
  },

  methods: {
    buy () {
      this.$emit('buy', { product: this.subscription, isBuy: true })
    }
  }
}
</script>

<style lang="scss" scoped>
.vvvpass {
  width: 100%;
  border-radius: 12px;
  background: $blue-grey70;
  color: $white;

  &__title {
    font-size: 18px;
    font-weight: 700;
    margin: 12px 0;

    @media(min-width: $breakpointTablet) {
      font-size: 20px;
    }
  }

  &__picture {
    position: relative;
    width: 100%;
    padding: 24px 32px;
    margin-bottom: 20px;
    border: 1px solid $light-blue60;
    border-radius: 16px;
    background-image: url(~@/assets/img/backgrounds/unlimited.png);
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;

    @media (min-width: $breakpointTablet) {
      background-image: url(~@/assets/img/backgrounds/unlimited_big.png);
      background-size: auto;
      background-position: right center;
    }

    @media (min-width: $breakpointDesktopBig) {
      background-image: url(~@/assets/img/backgrounds/unlimited_big.png);
      background-size: auto;
      background-position: right center;
    }

    &-label {
      position: absolute;
      bottom: 0;
      right: 0;
      padding: 6px 16px;
      background: $deep-blue50;
      border-radius: 16px 16px 0 16px;

      @media (min-width: $breakpointTablet) {
        bottom: auto;
        top: 0;
      }

      &--monthly {
        background: $pink50;
      }

      &-text {
        color: $white;
        font-size: 14px;
        font-weight: 700;
        line-height: 24px;
      }
    }
  }

  &__header {
    font-size: 18px;
    font-weight: 700;
    line-height: 22px;
    margin-bottom: 16px;
  }

  &__old {
    position: relative;
    margin-right: 28px;
    color: #90A4AE;
    font-weight: 500;
    font-size: 20px;

    &::before {
      position: absolute;
      width: 100%;
      height: 1px;
      top: 14px;
      background: #90A4AE;
      content: '';
    }
  }

  &__star {
    width: 16px;
    height: 16px;
  }

  &__points {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 8px;
    margin-bottom: 24px;
  }

  &__point {
    display: grid;
    grid-template-columns: max-content 1fr;
    grid-gap: 8px;
  }

  &__comment {
    margin-top: 16px;
    margin-bottom: 24px;
    color: $blue-grey05;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    min-height: 16px;
  }

  &__duration {
    color: $blue-grey05;
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
  }

  &__price {
    display: flex;
    align-items: center;
  }

  &__button {
    width: 100%;
    height: 48px;
    margin-top: 24px;
  }
}
</style>
